import { render, staticRenderFns } from "./ViewComp.vue?vue&type=template&id=871dafa8"
import script from "./ViewComp.vue?vue&type=script&lang=js"
export * from "./ViewComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports